
import React, { ChangeEvent } from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, Radio, RadioGroup, Typography } from '@material-ui/core';

import { RevisionContext } from '../RevisionContext';
import { HomeContext } from '../../../Home/HomeContext';
import { BasicConfirmDialog } from '../../../../shared/components/BasicConfirmDialog';
import { theme } from '../../../../theme';
import { SpotlightModel, spotlightModelInitial } from '../../../../Models/SpotlightModel';
import SpotlightService from '../../../../Services/SpotlightService';
import { spotlightBatchModelInitial } from '../../../../Models/SpotlightBatchModel';
import CategorySpotlightService from '../../../../Services/CategorySpotlightService';
import { BatchCorrectionContext } from '../BatchCorrectionContext';

export function SpotlightBatchCorrection() {

    const revisionContext = React.useContext(RevisionContext);
    const batchCorrectionContext = React.useContext(BatchCorrectionContext);
    const homeContext = React.useContext(HomeContext);

    const [spotlightSelected, setSpotlightSelected] = React.useState<SpotlightModel | null>(null);
    const [spotlights, setSpotlights] = React.useState<SpotlightModel[]>([]);

    const [spotlightError, setSpotlightError] = React.useState(false);

    React.useEffect(() => {
        if (revisionContext.spotlightBatchOpenDialog) {
            SpotlightService.spotlightService()
                .getAll()
                .then((res: AxiosResponse) => { setSpotlights(res.data); })
                .catch((error: AxiosError) => { homeContext.showError('', error); });
        }
    }, [revisionContext.spotlightBatchOpenDialog]);

    const hasError = () => {

        const errorSpotlight: boolean = spotlights && spotlights.length > 0 && !spotlightSelected;

        setSpotlightError(errorSpotlight);

        return (errorSpotlight);
    };

    const updateSpotlightBatch = () => {
        if (!hasError()) {
            homeContext.setOpenLoadingDialog(true);

            const spotlightData = { ...spotlightBatchModelInitial };
            spotlightData.spotlight = spotlightSelected ? spotlightSelected : spotlightModelInitial;
            spotlightData.categoriesId = revisionContext.ids;

            CategorySpotlightService.updateSpotlightBatch(spotlightData)
                .then(() => {
                    clearModalSpotlight();
                    homeContext.setOpenLoadingDialog(false);
                    homeContext.showSuccess(`As alterações foram realizadas para todas as ${revisionContext.ids.length} categorizações selecionadas com sucesso!`);
                    batchCorrectionContext.setCallSearch(true);
                })
                .catch((error: AxiosError) => {
                    homeContext.setOpenLoadingDialog(false);
                    homeContext.showError(' Ops... Ocorreu um erro e não foi possível salvar a alteração de destaque. '
                        + 'Por favor, tente novamente dentro de alguns instantes. <br/>', error);
                });
        }
    };

    const clearModalSpotlight = () => {
        revisionContext.setSpotlightBatchOpenDialog(false);
        setSpotlightSelected(null);
        setSpotlightError(false);
    };

    const getSpotlights = () => {
        return (
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <FormControl component="fieldset" error={spotlightError}>
                        <FormLabel component="legend" error={false}>
                            <Typography variant="subtitle1">Destaque</Typography>
                        </FormLabel>
                        <RadioGroup
                            row
                            value={spotlightSelected ? spotlightSelected.id.toString() : ''}
                            onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                setSpotlightSelected(spotlights.find(e => e.id == Number(event.target.value)) || null);
                            }}>
                            <Grid container spacing={3}>
                                {spotlights.map(spotlight =>
                                    <Grid item key={spotlight.id}>
                                        <FormControlLabel value={spotlight.id.toString()} control={<Radio color='primary' />} label={spotlight.name} />
                                    </Grid>
                                )}
                            </Grid>
                        </RadioGroup>
                        {spotlightError && !spotlightSelected && <FormHelperText>Selecione um destaque</FormHelperText>}
                    </FormControl>
                </Grid>
            </Grid>
        );
    };

    return (
        <BasicConfirmDialog
            title={'Alteração de destaque'}
            description={'Selecione o destaque que deseja para as categorizações selecionadas.'}
            handleFirstButton={() => clearModalSpotlight()}
            handleSecondButton={() => updateSpotlightBatch()}
            textFirstButton='DESCARTAR'
            textSecondButton='SALVAR'
            open={revisionContext.spotlightBatchOpenDialog}
            children={getSpotlights()}
            cssProperties={{
                minWidth: '800px',
                maxWidth: '800px',
                padding: '1rem',
                colorFirstButton: theme.palette.primary.main,
                justifyButtons: 'flex-end',
                titleVariant: 'h4',
                descriptionVariant: 'body1'
            }} />
    );
}